export const getUnblockMicHelperUrl = (browser: 'Chrome' | 'Edge' | 'Firefox' | 'Safari') => {
  return {
    Chrome: 'https://support.google.com/chrome/answer/2693767?hl=en&co=GENIE.Platform%3DDesktop',
    Edge: 'https://support.microsoft.com/en-us/windows/windows-camera-microphone-and-privacy-a83257bc-e990-d54a-d212-b5e41beba857#:~:text=In%20Microsoft%20Edge%2C%20select%20Settings,Permissions%2C%20select%20Camera%20or%20Microphone.',
    Firefox:
      'https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions#w_change-microphone-permissions',
    Safari: 'https://support.apple.com/guide/safari/websites-ibrwe2159f50/mac',
  }[browser]
}
